import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.adjustHeader()

    let _that = this
    window.addEventListener('scroll', function() {
      _that.adjustHeader()
    })
  }

  adjustHeader() {
    let navbar_height = document.getElementById('main-navigation').offsetHeight

    if (window.scrollY > navbar_height) {
      document.getElementById('header').classList.add('fixed-top', 'shadow-sm')
      document.body.style.paddingTop = document.getElementById('header').offsetHeight +'px'
    } else {
      document.getElementById('header').classList.remove('fixed-top', 'shadow-sm')
      document.body.style.paddingTop = '0'
    } 
  }

}